import { createStore, applyMiddleware, compose } from "redux"
import createSagaMiddleware from "redux-saga"
import thunk from "redux-thunk"

import rootReducer from "./reducers"
import rootSaga from "./sagas"
// import rootPerigourdineSaga from "./submoduleperigourdine/sagas"
import rootFormulaireSaga from "./submoduleform/sagas"

import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

const persistConfig = {
  key: "pocketResult",
  storage,
  blacklist: ["message", "formulaireReducer"],
}
const persistedReducer = persistReducer(persistConfig, rootReducer)

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

const sagaMiddleware = createSagaMiddleware()
const enhancers = composeEnhancers(applyMiddleware(sagaMiddleware, thunk))

export default (initialState = {}) => {
  let store = createStore(persistedReducer, initialState, enhancers)
  let persistor = persistStore(store)

  sagaMiddleware.run(rootSaga)
  // sagaMiddleware.run(rootPerigourdineSaga)
  sagaMiddleware.run(rootFormulaireSaga)

  return { store, persistor }
}
